import React from 'react';
import ReactDOM from 'react-dom/client';
import SouthHarborNet from './SouthHarborNet';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<SouthHarborNet />);